import { Pipe, PipeTransform } from '@angular/core';
import { ConfQuoteLine } from '../model';

@Pipe({
  name: 'productListLineTotalPrice',
  standalone: true,
  pure: false,
})
export class ProductListLineTotalPricePipe implements PipeTransform {
  transform(line: ConfQuoteLine): number {
    let valueWithDiscount: number = (1 - line.discount / 100) * line.price;
    let valueWithDiscount2: number =
      (1 - line.discount2 / 100) * valueWithDiscount;
    return parseFloat((line.qty * valueWithDiscount2).toFixed(2));
  }
}
